import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Logger } from '../Logger.service';
import { LoginService } from '../login/login.service';
import { forbiddenValidator } from '../shared/forbidden.validator';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit {
  resetPasswordForm: FormGroup;
  router: Router;

  constructor(
    private fb: FormBuilder,
    router: Router,
    private loginService: LoginService,
    private logger: Logger
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    this.resetPasswordForm = this.fb.group({
      userEmail: [
        ,
        {
          validators: [Validators.required, Validators.email],
          updateOn: 'change',
        },
      ],
      userPassword: [
        ,
        [Validators.required, Validators.minLength(8), forbiddenValidator()],
      ],
      confirmPassword: [
        ,
        [
          Validators.required,
          Validators.minLength(8),
          forbiddenValidator()
        ],
      ],
    });
  }

  get userEmail() {
    return this.resetPasswordForm.get('userEmail');
  }
  get userPassword() {
    return this.resetPasswordForm.get('userPassword');
  }
  get confirmPassword() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  passwordMatch() {
    return this.userPassword.value === this.confirmPassword.value;
  }

  resetPassword() {
    this.loginService
      .resetPassword(this.userEmail.value, this.userPassword.value)
      .subscribe((responseString) => {
        console.log('responseString: ' + responseString);
        console.log(
          'User Password validated for user: ' + this.userEmail.value
        );
      });
  }

  cancel(){

  }
  
  getEmailErrorMessage() {}

  getPasswordErrorMessage() {}
}
